exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ui.menu.topRightLinksMenu {\n  position: absolute;\n  right: 0;\n  z-index: 1000;\n  margin: 0 3rem 1rem 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/common/components/TopRightLinks.less
// module id = 956
// module chunks = 0